export const THEME_PRIMARY_COLOR = "primary_color";
export const THEME_SECONDARY_COLOR = "secondary_color";
export const THEME_MONOCHROME_COLOR = "monochrome_color";
export const DARK_GREY_COLOR = "#333333";

export const INHERIT_BUTTON_COLOR_FROM_THEME = "inherit";
export const INHERT_TEXT_COLOUR_FROM_THEME = "text_colour_inherit";
export const INHERT_OVERLAY_COLOUR_FROM_THEME = "overlay_colour_inherit";

export const THEME_PRIMARY_COLORS_LABEL = "Primary Colours";
export const THEME_SECONDARY_COLORS_LABEL = "Secondary Colors";
export const THEME_MONOCHROME_COLORS_LABEL = "Monochrome Colours";


/** WEBPACK FOOTER **
 ** ./src/constants/colourConstants.js
 **/